import { render, staticRenderFns } from "./ThirdCheck1.vue?vue&type=template&id=72365afc&scoped=true"
import script from "./ThirdCheck1.vue?vue&type=script&lang=js"
export * from "./ThirdCheck1.vue?vue&type=script&lang=js"
import style0 from "./ThirdCheck1.vue?vue&type=style&index=0&id=72365afc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72365afc",
  null
  
)

export default component.exports